import fetchFromNearMeCheck from 'src/near-me-check/api/fetch-from-backend';
import languages from 'src/shared/helpers/languages.json';

export const getCategories = async (
    queryString: string,
    language: keyof typeof languages,
    publicKey: string
) => {
    return fetchFromNearMeCheck(
        `/near-me-check/categories?language=${language.toLowerCase()}&q=${queryString}`,
        publicKey
    );
};
export const getCategoryById = async (
    id: number,
    language: keyof typeof languages,
    publicKey: string
) => {
    return fetchFromNearMeCheck(
        `/near-me-check/categories?categories=${id}&=language=${language.toLowerCase()}`,
        publicKey
    );
};
